import { STATUSES } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

export const statusesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getStatuses: build.query({
      query: (params = {}) => ({ url: STATUSES.LIST, method: 'GET', params }),
      providesTags: (result) => listTags('Status', result),
    }),
    getStatusesByModel: build.query({
      query: (model) => ({
        url: STATUSES.BY_MODEL(model),
        method: 'GET',
      }),
      providesTags: (_r, _e, model) => [{ type: 'Status', id: `model-${model}` }],
    }),
  }),
});

export const {
  useGetStatusesQuery,
  useLazyGetStatusesQuery,
  useGetStatusesByModelQuery,
  useLazyGetStatusesByModelQuery,
} = statusesApi;
